import React, {Component} from "react"
import {Progress} from "semantic-ui-react"
import api from "../../api"

export default class ServiceProgress extends Component {
  constructor() {
    super()
    this.state = {
      progress: api.getProgress(), indicating: false
    }
    api.signals.progress.add(this.progress)
  }

  progress = ({progress}) => {
    this.setState({progress, indicating: true})
    this.timeout_id = setTimeout(this.stopIndicating, 1700)
  }

  stopIndicating = () => {
    this.setState({indicating: false})
  }

  componentWillUnmount() {
    api.signals.progress.remove(this.progress)
    if (this.timeout_id) window.clearTimeout(this.timeout_id)
  }

  render() {
    let {progress} = this.state
    return <Progress style={{margin: "0 0 16px"}} percent={progress} progress indicating={this.state.indicating} autoSuccess color="grey"/>
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/ServiceProgress.js